define('bay_engage_reviews_body.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('bay_engage_reviews_body', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"_tbr_bus\"></div> ";
},"useData":true}, 'extensions/BayEngage/BayEngageReviews/1.0.0/', 'extensions/BayEngage/BayEngageReviews/1.0.0/', Handlebars);
});